<div class="container">
    <form [formGroup]="formulario">

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação De</mat-label>
                    <input matInput id="txtCreateIniDt" #txtCreateIniDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_inicial">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateIniDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação Até</mat-label>
                    <input matInput id="txtCreateFinDt" #txtCreateFinDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_final">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateFinDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Safra</mat-label>

                    <mat-select formControlName="safra" multiple>

                        <mat-option *ngFor="let item of filteredOptionsSafra | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                    </mat-select>

                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Centro de Ensaque</mat-label>
                    <input matInput name="centro_ensaque" formControlName="centro_ensaque" [matAutocomplete]="auto3"
                        maxlength="4" #txtCentroEnsaque id="txtCentroEnsaque" readonly class="InputBlockColor">
                    <mat-autocomplete #auto3="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsCentroEnsaque | async" [value]="item.initials">
                            {{item.initials | uppercase}}
                        </mat-option>
                    </mat-autocomplete>
                    <i matSuffix class="{{iconDisableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                    <mat-hint align="end">{{txtCentroEnsaque.value.length}} / 4</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Lote Origem</mat-label>
                    <input matInput name="txtLoteOrigem" formControlName="lote_origem" maxlength="17" #txtLoteOrigem
                        id="txtLoteOrigem">
                    <mat-hint align="end">{{txtLoteOrigem.value.length}} / 17</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Lote Saída</mat-label>
                    <input matInput name="txtLoteSaida" formControlName="lote_saida" maxlength="17" #txtLoteSaida
                        id="txtLoteSaida">
                    <mat-hint align="end">{{txtLoteSaida.value.length}} / 17</mat-hint>
                </mat-form-field>
            </div>

        </div>
        <div class="row pt-1">

            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Híbrido RNC</mat-label>
                    <mat-select formControlName="hibrido_rnc" multiple>
                        <input matInput type="text" class="form-control filterTxt"
                            placeholder="Pesquisar por..."
                            (keyup)="createFilterHibrido($event.target.value)">
                        <mat-option *ngFor="let item of listHibridoRnc" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Status</mat-label>
                    <mat-select name="status" formControlName="is_incomplete" disableOptionCentering>
                        <mat-option *ngFor="let item of listStatus" [value]="item.value">
                            {{item.value ? 'INCOMPLETO' : 'COMPLETO'}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Número do Campo</mat-label>
                    <input matInput formControlName="numero_campo">
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Data de Ensaque De</mat-label>
                    <input matInput id="txtDataInicio" #txtDataInicio maxlength="10" mask="d0/M0/0000"
                        formControlName="data_ensaque_inicial">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtDataInicio.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Data de Ensaque Até</mat-label>
                    <input matInput id="txtDataFim" #txtDataFim maxlength="10" mask="d0/M0/0000"
                        formControlName="data_ensaque_final">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtDataFim.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
        </div>


        <div class="row pt-2">
            <div class="col-lg col-md text-right">
                <button mat-flat-button color="primary" matTooltip="Limpar" class="textoGeral mr-1"
                    (click)="clearFilter()"><i class="fa fa-paint-brush" aria-hidden="true"></i> Limpar</button>
                <button mat-flat-button color="primary" matTooltip="Pesquisar" class="textoGeral mr-1"
                    (click)="sendFilter()"><i class="fa fa-search" aria-hidden="true"></i> Pesquisar</button>
            </div>
        </div>
    </form>
</div>